var favorite = "https://shopfront-cdn.tekoapis.com/static/6859bf852118defe.svg";

export { favorite as default };
